import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { DefeitoCatalogo } from '../../types/qualidade';
import { defeitosCatalogoService } from '../../services';

const columns: ResourceColumn<DefeitoCatalogo>[] = [
  { header: 'Código', accessor: 'codigo' },
  { header: 'Descrição', accessor: 'descricao' },
  { header: 'Severidade', accessor: 'severidade' },
  { header: 'Ativo', render: (item) => (item.ativo === false ? 'Não' : 'Sim') },
];

export const DefeitosCatalogoListPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <ResourceListPage
      title="Defeitos (catálogo)"
      description="Tipos de defeitos disponíveis para inspeções."
      columns={columns}
      service={defeitosCatalogoService}
      createPath="/admin/parametros/defeitos-catalogo/novo"
      onEdit={(item) =>
        (item as { id?: number }).id &&
        navigate('/admin/parametros/defeitos-catalogo/editar', { state: { record: item } })
      }
      onDelete={(item) =>
        (item as { id?: number }).id ? defeitosCatalogoService.remove((item as any).id) : Promise.resolve()
      }
    />
  );
};
